export const removeLastElement = (arr) => {
  const [, ...rest] = arr.reverse()
  return rest.reverse()
}
